<!-- Main Content -->
<div class="container">
  <div class="privacy-container" [ngClass]="isOuterRoute ? 'privacy-container outer' : 'privacy-container inner'">
  <div *ngIf="conditions">
  <!-- Wrap the HTML from backend with your CSS scope -->
  <div class="privacy-content" [innerHTML]="displayContent | safeHtml"></div>
</div>
  </div>
</div>